import React, { Component } from 'react'
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend
} from 'recharts';

class CardBartChart extends Component {

  constructor(props) {
    super(props)
    this.state = {
      activeIndex: 0,
      title: this.props.title,
      subtitle:this.props.subtitle,
      data: this.props.data,
      dataKey: this.props.dataKey
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) this.setState({ data: this.props.data })
  }

  onPieEnter = (data, index) => {
    this.setState({
      activeIndex: index,
    });
  };

  render() {
    const isPercentage = this.props.yAxisType === "percentage";
    return (
      <div>
        <div className="padding-10px background-white border-bottom">
          <div className="txt-site txt-bold text-main txt-12">
            { this.state.title }
          </div>
          {(this.state.subtitle) ? 
          <div className="txt-site txt-thin text-primary txt-9 margin-top-5px">
            { this.state.subtitle }
          </div>
          : null}
        </div>
        <div>
          <div className="padding-10px txt-site txt-9">
            <ResponsiveContainer 
              width='100%'
              aspect={4.0/1.8}>
              <BarChart
                // width={500}
                // height={300}
                data={this.state.data}
                margin={{
                  top: 0,
                  right: 20,
                  left: 40,   
                  bottom: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="division" />
                {/* <YAxis /> */}
                <YAxis
                  width={80}
                  allowDecimals={false}
                  domain={isPercentage ? [0, 100] : ["auto", "auto"]}
                  tickFormatter={(v) =>
                    isPercentage
                      ? Math.round(v)
                      : this.props.yAxisFormatter?.(v) ?? v
                  }
                />
                <Tooltip
                  formatter={(v) => `${Number(v).toLocaleString("id-ID")}`}
                />
                 <Legend />

                {
                    this.state.dataKey.map(
                      (entry, index) => <Bar 
                        key={index}
                        // key={`bar-${index}`}
                        stackId='stack'
                        dataKey={entry.key}
                        fill={entry.color} />
                    )
                }

                {/* <Bar dataKey="pv" fill="#8884d8" />
                <Bar dataKey="uv" fill="#82ca9d" /> */}
            </BarChart>
            </ResponsiveContainer>

            {/*<div className="padding-15px">*/}
            {/*  <div className="display-flex-normal txt-site txt-center" style={{margin: 'auto'}}>*/}
            {/*    { this.BarInfo() }*/}
            {/*  </div>*/}
            {/*</div>*/}

          </div>
        </div>
      </div>
    )
  }

  BarInfo = () => {
    let dt = []
    let val = this.state.dataKey.length

    for (let index = 0; index < val; index++) {
      dt.push(
        <div className="display-flex-normal padding-5px" key={index}>
          <div className="width width-20px">
            <span 
              className="fa fa-lw fa-circle" 
              style={{color: this.state.dataKey[index].color}} /> 
          </div>
          <div className="txt-site txt-main txt-thin txt-11">
            { this.state.dataKey[index].bizValue }
          </div>
        </div>
      )
    }

    return dt
  }

}

export default CardBartChart